/* Cocoon slide cart: draws Shopify's cart (/cart.js) in a drawer and replaces the Haven quick cart. */
(function () {
  'use strict';
  var root = document.getElementById('CocoonCart');
  var cfgEl = document.getElementById('CocoonCartConfig');
  /* window.cocoonCart, not CocoonCart: the element id already claims that global name. */
  if (!root || !cfgEl || window.cocoonCart) return;

  var cfg = JSON.parse(cfgEl.textContent);
  var BASE = (cfg.root || '/').replace(/\/?$/, '/');
  var body = root.querySelector('[data-ccc-body]');
  var foot = root.querySelector('[data-ccc-foot]');
  var countEl = root.querySelector('[data-ccc-count]');
  var live = root.querySelector('[data-ccc-live]');
  var panel = root.querySelector('.ccc__panel');
  /* The promo badge is rendered by the section but drawn at the top of the scrolling list, so it is not sticky. */
  var announceEl = root.querySelector('.ccc__announce');
  var announceHtml = announceEl ? announceEl.outerHTML : '';
  if (announceEl) announceEl.remove();

  /* Our own requests use the original fetch, so the hook below only reacts to other scripts. */
  var nativeFetch = window.fetch.bind(window);
  var cart = null, products = {}, productData = {}, refreshing = null, lastFocus = null, picks = {};
  /* Promo code field: open state, last message and the typed code survive re-renders. */
  var code = { open: false, msg: null, draft: '' };
  /* Interface text follows the storefront language (<html lang>); French is the default. */
  var EN = /^en/i.test(document.documentElement.lang);
  var T = EN ? {
    error: 'Error', remove: function (t) { return 'Remove ' + t + ' from cart'; }, qty: function (t) { return 'Quantity, ' + t; },
    dec: 'Decrease quantity', inc: 'Increase quantity', save: 'Save ', removeCode: function (c) { return 'Remove code ' + c; },
    promo: 'Promo code', enterCode: 'Enter your code', apply: 'Apply', another: 'Add another code', haveCode: 'Have a promo code?',
    needCode: 'Enter a promo code.', already: 'This code is already applied.', applied: function (c) { return 'Code ' + c + ' applied.'; },
    invalid: 'This code is not valid for this cart.', failed: 'The code could not be checked. Please try again.', removed: function (c) { return 'Code ' + c + ' removed.'; },
    summary: 'Order summary', total: 'Total', checkout: 'Check out', reserve: 'Your cart is reserved for', best: 'Our best sellers',
    upsell: 'Complete your cocoon', add: 'Add', addTitle: function (t) { return 'Add ' + t + ' to cart'; }, soldOut: 'Sold out', prev: 'Previous product', next: 'Next product',
    adding: 'Adding…', added: function (t) { return t + ' added to cart.'; }, protection: 'Shipping protection', addProt: function (p) { return 'Add shipping protection, ' + p; },
    protOn: 'Shipping protection added.', protOff: 'Shipping protection removed.', items: function (n) { return n + (n > 1 ? ' items' : ' item'); },
    empty: 'Your cart is empty', emptyText: 'Discover our linen and muslin bedding, designed in Canada for better sleep.', shop: 'Shop now',
    qtyDone: 'Quantity updated.', lineGone: 'Item removed from cart.'
  } : {
    error: 'Erreur', remove: function (t) { return 'Retirer ' + t + ' du panier'; }, qty: function (t) { return 'Quantité, ' + t; },
    dec: 'Diminuer la quantité', inc: 'Augmenter la quantité', save: 'Économisez ', removeCode: function (c) { return 'Retirer le code ' + c; },
    promo: 'Code promo', enterCode: 'Entrez votre code', apply: 'Appliquer', another: 'Ajouter un autre code', haveCode: 'Vous avez un code promo ?',
    needCode: 'Entrez un code promo.', already: 'Ce code est déjà appliqué.', applied: function (c) { return 'Code ' + c + ' appliqué.'; },
    invalid: 'Ce code n’est pas valide pour ce panier.', failed: 'Le code n’a pas pu être vérifié. Réessayez.', removed: function (c) { return 'Code ' + c + ' retiré.'; },
    summary: 'Récapitulatif', total: 'Total', checkout: 'Passer à la caisse', reserve: 'Votre panier est réservé pendant', best: 'Nos meilleurs vendeurs',
    upsell: 'Complétez votre cocon', add: 'Ajouter', addTitle: function (t) { return 'Ajouter ' + t + ' au panier'; }, soldOut: 'Épuisé', prev: 'Produit précédent', next: 'Produit suivant',
    adding: 'Ajout…', added: function (t) { return t + ' ajouté au panier.'; }, protection: 'Protection de livraison', addProt: function (p) { return 'Ajouter la protection de livraison, ' + p; },
    protOn: 'Protection de livraison ajoutée.', protOff: 'Protection de livraison retirée.', items: function (n) { return n + (n > 1 ? ' articles' : ' article'); },
    empty: 'Votre panier est vide', emptyText: 'Découvrez notre literie en lin et en mousseline, pensée au Québec pour mieux dormir.', shop: 'Magasiner',
    qtyDone: 'Quantité mise à jour.', lineGone: 'Article retiré du panier.'
  };
  var money = function (cents) {
    return new Intl.NumberFormat(EN ? 'en-CA' : 'fr-CA', { style: 'currency', currency: (cart && cart.currency) || 'CAD' }).format(cents / 100);
  };

  document.documentElement.classList.add('ccc-on');

  /* ---------- Shopify cart API ---------- */
  function api(path, data) {
    var opts = { headers: { Accept: 'application/json' } };
    if (data) { opts.method = 'POST'; opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(data); }
    return nativeFetch(BASE + path, opts).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || T.error); return d; });
    });
  }
  /* Compare-at prices are not in /cart.js; they come from each product's JSON, fetched once per handle. */
  function product(handle) {
    if (!products[handle]) {
      products[handle] = nativeFetch(BASE + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
        .then(function (p) { productData[handle] = p; return p; });
    }
    return products[handle];
  }
  function compareUnit(line) {
    var p = productData[line.handle];
    var v = p && p.variants.filter(function (x) { return x.id === line.variant_id; })[0];
    return Math.max((v && v.compare_at_price) || 0, line.original_price);
  }

  /* A refresh asked for while one is running (the cart changed in between) runs once more after it. */
  var refreshAgain = false;
  function refresh() {
    if (refreshing) {
      refreshAgain = true;
      return refreshing.then(function () { if (refreshAgain) { refreshAgain = false; return refresh(); } });
    }
    refreshing = api('cart.js')
      .then(function (c) {
        cart = c;
        var handles = c.item_count ? c.items.map(function (i) { return i.handle; }).concat(upsellHandles(), cfg.protection ? [cfg.protection.handle] : []) : (cfg.bestsellers || []);
        return Promise.all(handles.map(product));
      })
      .then(render)
      .catch(function () { if (cart) render(); })
      .then(function () { refreshing = null; });
    return refreshing;
  }

  /* ---------- Rendering ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(src, w) { return src ? src + (src.indexOf('?') < 0 ? '?' : '&') + 'width=' + w : ''; }
  var ICON = {
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    minus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4.5" y="10.5" width="15" height="10" rx="2"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 8h14l-1 12H6z"/><path d="M9 8V6a3 3 0 0 1 6 0v2"/></svg>',
    /* Same icons as the badges under the add-to-cart button on the product pages. */
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.6"/><circle cx="17" cy="17.5" r="1.6"/></svg>',
    moon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3 4.5 6v5.5c0 4.6 3.2 8.4 7.5 9.5 4.3-1.1 7.5-4.9 7.5-9.5V6z"/><path d="m8.8 12.2 2.2 2.2 4.3-4.4"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>',
    chev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>',
    arrow: '<svg class="ccc__arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'
  };

  /* Option values only ("Rose Pétale · Lit Double/Queen"), plus any visible line properties. */
  function optsText(line) {
    var parts = (line.options_with_values || []).filter(function (o) { return o.value && o.value !== 'Default Title'; })
      .map(function (o) { return esc(o.value); });
    Object.keys(line.properties || {}).forEach(function (k) {
      if (k.charAt(0) !== '_' && line.properties[k]) parts.push(esc(k) + ' : ' + esc(line.properties[k]));
    });
    return parts.join(' · ');
  }

  function lineHtml(line) {
    var cmp = compareUnit(line) * line.quantity, paid = line.final_line_price;
    var save = cmp - paid, pct = cmp ? Math.round(save / cmp * 100) : 0;
    var title = esc(line.product_title.replace(/^Cocoon™\s*/, ''));
    var href = esc(line.url || (BASE + 'products/' + line.handle));
    return '<li class="ccc__line" data-key="' + esc(line.key) + '">' +
      '<a class="ccc__img" href="' + href + '" tabindex="-1" aria-hidden="true">' + (line.image ? '<img src="' + esc(img(line.image, 200)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
      '<div class="ccc__info">' +
        '<div class="ccc__top"><a class="ccc__name" href="' + href + '">' + title + '</a>' +
          '<button type="button" class="ccc__rm" data-ccc-rm aria-label="' + T.remove(title) + '">' + ICON.x + '</button></div>' +
        '<p class="ccc__opts">' + optsText(line) + '</p>' +
        '<div class="ccc__bottom">' +
          '<div class="ccc__qty" role="group" aria-label="' + T.qty(title) + '">' +
            '<button type="button" data-ccc-step="-1" aria-label="' + T.dec + '"' + (line.quantity <= 1 ? ' disabled' : '') + '>' + ICON.minus + '</button>' +
            '<span aria-live="polite">' + line.quantity + '</span>' +
            '<button type="button" data-ccc-step="1" aria-label="' + T.inc + '">' + ICON.plus + '</button></div>' +
          '<div class="ccc__price"><div class="ccc__now">' + (save > 0 ? '<s>' + money(cmp) + '</s>' : '') + money(paid) + '</div>' +
            (save > 0 ? '<span class="ccc__badge">−' + pct + '&nbsp;% · ' + T.save + money(save) + '</span>' : '') + '</div>' +
        '</div>' +
      '</div></li>';
  }

  /* ---------- Promo codes ----------
     Shopify keeps the codes on the cart: /cart/update.js { discount: "A,B" } sets the full list,
     and /cart.js reports each one in discount_codes with applicable: true/false. */
  function cartCodes() {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
  }
  function codeAmount(c) {
    var a = (cart.cart_level_discount_applications || []).filter(function (x) { return String(x.title).toLowerCase() === c.toLowerCase(); })[0];
    return a ? a.total_allocated_amount : 0;
  }
  function codeHtml() {
    if (cfg.discountCodes === false) return '';
    var codes = cartCodes();
    return '<div class="ccc__code">' +
      (codes.length ? '<ul class="ccc__codes" role="list">' + codes.map(function (c) {
        var amt = codeAmount(c);
        return '<li class="ccc__chip">' + ICON.tag + '<span>' + esc(c) + (amt ? ' · −' + money(amt) : '') + '</span>' +
          '<button type="button" data-ccc-code-rm="' + esc(c) + '" aria-label="' + esc(T.removeCode(c)) + '">' + ICON.x + '</button></li>';
      }).join('') + '</ul>' : '') +
      (code.open
        ? '<form class="ccc__code-form" data-ccc-code-form novalidate><label class="ccc__sr" for="CccCode">' + T.promo + '</label>' +
            '<input id="CccCode" name="code" type="text" value="' + esc(code.draft) + '" placeholder="' + T.enterCode + '" autocomplete="off" autocapitalize="characters" spellcheck="false" enterkeyhint="done">' +
            '<button type="submit">' + T.apply + '</button></form>'
        : '<button type="button" class="ccc__code-toggle" data-ccc-code-toggle>' + ICON.tag +
            '<span>' + (codes.length ? T.another : T.haveCode) + '</span>' + ICON.chev + '</button>') +
      (code.msg ? '<p class="ccc__code-msg' + (code.msg.err ? ' is-error' : '') + '" role="status">' + esc(code.msg.text) + '</p>' : '') +
    '</div>';
  }
  function drawFoot(focusInput) {
    foot.innerHTML = footHtml();
    var input = focusInput && foot.querySelector('#CccCode');
    if (input) { input.focus(); input.setSelectionRange(input.value.length, input.value.length); }
  }
  function applyCode(value) {
    var c = value.trim(), codes = cartCodes();
    code.draft = c;
    if (!c) { code.msg = { text: T.needCode, err: true }; drawFoot(true); return; }
    if (codes.some(function (x) { return x.toLowerCase() === c.toLowerCase(); })) {
      code.msg = { text: T.already, err: true }; drawFoot(true); return;
    }
    var btn = foot.querySelector('[data-ccc-code-form] button');
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    api('cart/update.js', { discount: codes.concat(c).join(',') })
      .then(function (res) {
        var hit = (res.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === c.toLowerCase(); })[0];
        if (hit && hit.applicable) {
          code = { open: false, msg: { text: T.applied(hit.code), err: false }, draft: '' };
          return refresh();
        }
        /* Shopify keeps a refused code on the cart; take it back off so only working codes remain. */
        code.msg = { text: T.invalid, err: true };
        return api('cart/update.js', { discount: codes.join(',') }).then(refresh).then(function () { drawFoot(true); });
      })
      .catch(function () { code.msg = { text: T.failed, err: true }; drawFoot(true); });
  }
  function removeCode(c) {
    code.msg = null;
    api('cart/update.js', { discount: cartCodes().filter(function (x) { return x !== c; }).join(',') })
      .then(refresh)
      .then(function () { live.textContent = T.removed(c); });
  }

  function footHtml() {
    var total = cart.total_price;
    var badges = (cfg.badges || []).filter(Boolean);
    return '<section aria-label="' + T.summary + '">' +
      protHtml() +
      codeHtml() +
      '<div class="ccc__row ccc__row--total"><span>Total</span><b>' + money(total) + '</b></div>' +
      '<div class="ccc__cta">' +
        '<a class="ccc__checkout" href="/checkout">' + ICON.lock + '<span>' + esc(cfg.checkoutLabel || T.checkout) + '</span>' + ICON.arrow + '</a>' +
        (reserveMs() > 0 ? '<p class="ccc__reserve" data-ccc-reserve>' + esc(cfg.reserveText || T.reserve) + ' <b data-ccc-timer>' + clock(reserveMs()) + '</b></p>' : '') +
      '</div>' +
      (badges.length ? '<ul class="ccc__badges" role="list">' + badges.map(function (b, i) {
        return '<li class="ccc__pill">' + (i === 0 ? ICON.truck : ICON.moon) + '<span>' + esc(b) + '</span></li>';
      }).join('') + '</ul>' : '') +
      '</section>';
  }

  /* ---------- Reservation timer ----------
     Starts when the first item enters the cart, lasts cfg.reserveMinutes, then the line disappears.
     It never restarts on its own; an emptied cart clears it so the next cart gets a fresh window. */
  var RESERVE_KEY = 'cccReserveUntil', timer = null;
  function store(k, v) { try { if (v == null) localStorage.removeItem(k); else localStorage.setItem(k, String(v)); } catch (e) {} }
  function stored(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function syncReserve(count) {
    if (!cfg.reserveMinutes) return;
    if (!count) { store(RESERVE_KEY, null); return; }
    if (!stored(RESERVE_KEY)) store(RESERVE_KEY, Date.now() + cfg.reserveMinutes * 60000);
  }
  function reserveMs() { var t = +stored(RESERVE_KEY); return cfg.reserveMinutes && t ? Math.max(0, t - Date.now()) : 0; }
  function clock(ms) {
    var s = Math.ceil(ms / 1000), m = Math.floor(s / 60);
    return m + ' min ' + (s % 60 < 10 ? '0' : '') + (s % 60) + ' s';
  }
  function tick() {
    var el = root.querySelector('[data-ccc-reserve]');
    if (!el) return;
    var ms = reserveMs();
    if (ms <= 0) { el.remove(); return; }
    el.querySelector('[data-ccc-timer]').textContent = clock(ms);
  }

  /* Best sellers under the empty-cart message: same quick-add card as the upsells. */
  function bestHtml() {
    var cards = (cfg.bestsellers || []).map(upHtml).filter(Boolean);
    if (!cards.length) return '';
    return '<section class="ccc__best" aria-labelledby="CccBestTitle">' +
      '<h3 class="ccc__best-title" id="CccBestTitle">' + esc(cfg.bestTitle || T.best) + '</h3>' +
      '<ul class="ccc__best-list" role="list">' + cards.join('') + '</ul></section>';
  }

  /* ---------- Upsells ----------
     cfg.upsells is a list of { triggers: [handles], items: [handles] }. When a trigger product is in the cart,
     its items are offered under the lines (minus anything already in the cart), each with its own colour and size.
     A rule's triggers are versions of the same product (the two linen sheet set listings, the two toppers):
     once one is in the cart, none of them is offered. */
  function upsellHandles() {
    if (!cart) return [];
    var skip = {}, out = [];
    cart.items.forEach(function (i) { skip[i.handle] = true; });
    var hits = (cfg.upsells || []).filter(function (r) {
      return (r.triggers || []).some(function (h) { return cart.items.some(function (i) { return i.handle === h; }); });
    });
    hits.forEach(function (r) { r.triggers.forEach(function (h) { skip[h] = true; }); });
    hits.forEach(function (r) {
      (r.items || []).forEach(function (h) { if (!skip[h] && out.indexOf(h) < 0) out.push(h); });
    });
    return out;
  }
  /* First visit: the first available variant, with the size switched to the one already in the cart when this product offers it.
     Sizes are named differently across products ("Lit Double/Queen" vs "Lit Double"), so a value also matches one of its "/" parts. */
  function sameSize(a, b) {
    return a === b || a.split('/').indexOf(b) > -1 || b.split('/').indexOf(a) > -1;
  }
  function defaultPick(p) {
    var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
    var pick = v.options.slice();
    p.options.forEach(function (o, i) {
      if (/^(couleur|colou?r)$/i.test(o.name)) return;
      cart.items.forEach(function (line) {
        (line.options_with_values || []).forEach(function (ov) {
          if (ov.name !== o.name) return;
          var hit = o.values.filter(function (val) { return sameSize(val, ov.value); })[0];
          if (hit) pick[i] = hit;
        });
      });
    });
    return pick;
  }
  function pickedVariant(p) {
    /* Only what the shopper picked is remembered; the default follows the cart as it changes. */
    var pick = picks[p.handle] || defaultPick(p);
    var same = function (v, n) { for (var i = 0; i < n; i++) if (v.options[i] !== pick[i]) return false; return true; };
    return p.variants.filter(function (v) { return same(v, pick.length); })[0] ||
      p.variants.filter(function (v) { return same(v, 1); })[0] || p.variants[0];
  }
  /* Swatch colours, same values as the product pages (linen palette, muslin palette for muslin products).
     Names are matched without case; an unknown colour simply gets no dot. */
  var SWATCH = {
    'rose pétale': '#E7D8D0', 'blanc': '#FFFFFF', 'citrouille': '#C28557', 'olive': '#82795A', 'beige': '#E9E4DB',
    'bleu marine': '#243851', 'gris': '#7C7C7C', 'espresso': '#5B4231', 'noir': '#1C1C1C',
    'brun': '#6B4A3A', 'gris nuage': '#B9BCC0', 'wasabi': '#A9B37E', 'beurre': '#EEDFA8', 'rose': '#E8B9C0', 'lavande': '#C9BEDF',
    'vin rouge': '#6E2B33', 'vert forêt': '#2F4B3A', 'violet': '#7D5A8C', 'bleu ciel': '#B4DEED', 'gris foncé': '#4A4A4A',
    /* English names of the same colours (storefront in English). */
    'petal pink': '#E7D8D0', 'white': '#FFFFFF', 'pumpkin': '#C28557', 'navy': '#243851', 'grey': '#7C7C7C', 'black': '#1C1C1C',
    'brown': '#6B4A3A', 'cloud grey': '#B9BCC0', 'butter': '#EEDFA8', 'pink': '#E8B9C0', 'lavender': '#C9BEDF',
    'red wine': '#6E2B33', 'forest green': '#2F4B3A', 'purple': '#7D5A8C', 'sky blue': '#B4DEED', 'dark grey': '#4A4A4A'
  };
  var SWATCH_MUSLIN = {
    'avoine': '#D6CCC2', 'luna': '#B9BEC1', 'rose pétale': '#CFAFA6', 'blanc': '#FFFFFF', 'olive': '#9E9D8A',
    'bleu marine': '#4B5463', 'lilas': '#CFC4CE', 'chai': '#C4AE9F', 'crème au beurre': '#DDCFA9',
    'oat': '#D6CCC2', 'petal pink': '#CFAFA6', 'white': '#FFFFFF', 'navy': '#4B5463', 'lilac': '#CFC4CE', 'buttercream': '#DDCFA9'
  };
  function swatch(handle, value) {
    var k = String(value).toLowerCase(), muslin = /mousseline|muslin|linen-rose™$/.test(handle);
    return (muslin && SWATCH_MUSLIN[k]) || SWATCH[k] || '';
  }

  function upHtml(h) {
    var p = productData[h];
    if (!p || !p.available) return '';
    var v = pickedVariant(p);
    var title = esc(p.title.replace(/^Cocoon™\s*/, ''));
    var href = esc(BASE + 'products/' + p.handle);
    var src = (v.featured_image && v.featured_image.src) || p.featured_image;
    var cmp = v.compare_at_price > v.price ? v.compare_at_price : 0;
    var selects = p.options.filter(function (o) { return o.values.length > 1; }).map(function (o) {
      var i = p.options.indexOf(o);
      var dot = /couleur|colou?r/i.test(o.name) && swatch(p.handle, v.options[i]);
      return '<label class="ccc__sel' + (dot ? ' ccc__sel--color' : '') + '"><span class="ccc__sr">' + esc(o.name) + '</span>' +
        (dot ? '<span class="ccc__dot" style="background:' + dot + '" aria-hidden="true"></span>' : '') +
        '<select data-ccc-opt="' + i + '">' +
        o.values.map(function (val) { return '<option' + (val === v.options[i] ? ' selected' : '') + '>' + esc(val) + '</option>'; }).join('') +
        '</select></label>';
    }).join('');
    return '<li class="ccc__up" data-up="' + esc(h) + '">' +
      '<a class="ccc__up-img" href="' + href + '" tabindex="-1" aria-hidden="true">' + (src ? '<img src="' + esc(img(src, 160)) + '" alt="" width="60" height="60" loading="lazy">' : '') + '</a>' +
      '<div class="ccc__up-info"><a class="ccc__up-name" href="' + href + '">' + title + '</a>' +
        (selects ? '<div class="ccc__up-sels">' + selects + '</div>' : '') +
        '<p class="ccc__up-price">' + (cmp ? '<s>' + money(cmp) + '</s> ' : '') + '<b>' + money(v.price) + '</b></p></div>' +
      '<button type="button" class="ccc__up-add" data-ccc-add' + (v.available ? '' : ' disabled') + ' aria-label="' + T.addTitle(title) + '">' +
        (v.available ? ICON.plus + '<span>' + T.add + '</span>' : '<span>' + T.soldOut + '</span>') + '</button>' +
    '</li>';
  }
  function upsellsHtml() {
    var cards = upsellHandles().map(upHtml).filter(Boolean);
    if (!cards.length) return '';
    return '<section class="ccc__ups" aria-labelledby="CccUpsTitle">' +
      '<div class="ccc__ups-head"><h3 class="ccc__ups-title" id="CccUpsTitle">' + esc(cfg.upsellTitle || T.upsell) + '</h3>' +
        (cfg.upsellNote ? '<span class="ccc__ups-note">' + ICON.tag + esc(cfg.upsellNote) + '</span>' : '') +
        (cards.length > 1 ? '<div class="ccc__ups-nav"><button type="button" data-ccc-slide="-1" aria-label="' + T.prev + '">' + ICON.chev + '</button>' +
          '<button type="button" data-ccc-slide="1" aria-label="' + T.next + '">' + ICON.chev + '</button></div>' : '') +
      '</div><ul class="ccc__ups-track" role="list">' + cards.join('') + '</ul></section>';
  }
  function addUpsell(card) {
    var p = productData[card.getAttribute('data-up')], v = p && pickedVariant(p);
    if (!v || !v.available) return;
    var btn = card.querySelector('[data-ccc-add]');
    btn.disabled = true;
    btn.innerHTML = '<span>' + T.adding + '</span>';
    api('cart/add.js', { items: [{ id: v.id, quantity: 1 }] })
      .then(function () { return refresh(); })
      .then(function () { live.textContent = T.added(p.title); })
      .catch(function (e) { btn.disabled = false; btn.innerHTML = ICON.plus + '<span>' + T.add + '</span>'; live.textContent = e.message; });
  }

  /* ---------- Delivery protection ----------
     An opt-in product (cfg.protection.handle). Its line is drawn as a switch in the footer, never as a cart line,
     and it is not counted as an article. A cart left with only the protection is emptied. */
  /* With cfg.protection.auto, the protection is added as soon as the cart holds a product. A shopper who
     switches it off keeps it off for this cart (remembered until the cart is emptied). */
  var PROT_OFF = 'cccProtOff', protAuto = false;
  function autoProt(count) {
    if (!count) { store(PROT_OFF, null); return; }
    var p = cfg.protection && cfg.protection.auto && productData[cfg.protection.handle];
    if (!p || !p.variants[0].available || protLine() || protAuto || stored(PROT_OFF)) return;
    protAuto = true;
    api('cart/add.js', { items: [{ id: p.variants[0].id, quantity: 1 }] })
      .then(function () { protAuto = false; return refresh(); })
      .catch(function () { protAuto = false; });
  }
  function isProt(item) { return !!cfg.protection && item.handle === cfg.protection.handle; }
  function protLine() { return cart.items.filter(isProt)[0]; }
  function goods() { return cart.items.filter(function (i) { return !isProt(i); }); }
  function protHtml() {
    var p = cfg.protection && productData[cfg.protection.handle], v = p && p.variants[0];
    if (!v || !v.available) return '';
    var on = !!protLine() || protAuto;
    return '<label class="ccc__prot' + (on ? ' is-on' : '') + '">' +
      '<span class="ccc__prot-icon">' + ICON.shield + '</span>' +
      '<span class="ccc__prot-text"><b>' + esc(cfg.protection.title || T.protection) + '</b>' +
        '<small>' + esc(cfg.protection.text || '') + '</small></span>' +
      '<span class="ccc__prot-price">' + money(v.price) + '</span>' +
      '<input type="checkbox" class="ccc__switch" role="switch" data-ccc-prot' + (on ? ' checked' : '') + ' aria-label="' + esc(T.addProt(money(v.price))) + '">' +
    '</label>';
  }
  function setProt(on, input) {
    var p = productData[cfg.protection.handle], line = protLine();
    store(PROT_OFF, on ? null : '1');
    input.disabled = true;
    var req = on ? api('cart/add.js', { items: [{ id: p.variants[0].id, quantity: 1 }] }) : (line ? api('cart/change.js', { id: line.key, quantity: 0 }) : Promise.resolve());
    req.then(refresh)
      .then(function () { live.textContent = on ? T.protOn : T.protOff; })
      .catch(function (e) { input.checked = !on; input.disabled = false; live.textContent = e.message; });
  }

  function render() {
    var count = goods().reduce(function (s, i) { return s + i.quantity; }, 0);
    if (!count && protLine()) { api('cart/change.js', { id: protLine().key, quantity: 0 }).then(refresh); }
    autoProt(count);
    syncReserve(count);
    countEl.textContent = count ? T.items(count) : '';
    updateHeaderBadge(count);
    if (!count) {
      var best = bestHtml();
      body.innerHTML = announceHtml + '<div class="ccc__empty' + (best ? ' ccc__empty--compact' : '') + '"><span class="ccc__empty-icon">' + ICON.bag + '</span>' +
        '<p class="ccc__empty-title">' + esc(cfg.emptyText || T.empty) + '</p>' +
        (best ? '' : '<p class="ccc__empty-text">' + T.emptyText + '</p>') +
        '<a class="ccc__btn" href="' + esc(cfg.emptyLink || BASE + 'collections/all') + '">' + T.shop + '</a></div>' + best;
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = announceHtml + '<ul class="ccc__lines" role="list">' + goods().map(lineHtml).join('') + '</ul>' + upsellsHtml();
    foot.innerHTML = footHtml();
  }

  function updateHeaderBadge(count) {
    document.querySelectorAll('[data-sub-id="quickCart"][data-open-overlay]').forEach(function (el) {
      var b = el.querySelector('.ccc-count-badge');
      if (!b) { b = document.createElement('span'); b.className = 'ccc-count-badge'; b.setAttribute('aria-hidden', 'true'); el.style.position = el.style.position || 'relative'; el.appendChild(b); }
      b.textContent = count > 99 ? '99+' : String(count);
      b.hidden = !count;
    });
  }

  /* ---------- Actions ---------- */
  function setQty(key, qty) {
    var line = body.querySelector('[data-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (line) line.classList.add('is-busy');
    return api('cart/change.js', { id: key, quantity: qty })
      .then(function () { return refresh(); })
      .then(function () { live.textContent = qty ? T.qtyDone : T.lineGone; })
      .catch(function (e) { if (line) line.classList.remove('is-busy'); live.textContent = e.message; });
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-ccc-close]')) { close(); return; }
    var lineEl = t.closest('[data-key]');
    var step = t.closest('[data-ccc-step]');
    if (step && lineEl) {
      var line = cart.items.filter(function (i) { return i.key === lineEl.getAttribute('data-key'); })[0];
      if (line) setQty(line.key, Math.max(0, line.quantity + parseInt(step.getAttribute('data-ccc-step'), 10)));
      return;
    }
    if (t.closest('[data-ccc-rm]') && lineEl) { setQty(lineEl.getAttribute('data-key'), 0); return; }
    if (t.closest('[data-ccc-code-toggle]')) { code.open = true; code.msg = null; drawFoot(true); return; }
    var rmCode = t.closest('[data-ccc-code-rm]');
    if (rmCode) { removeCode(rmCode.getAttribute('data-ccc-code-rm')); return; }
    var add = t.closest('[data-ccc-add]');
    if (add) { addUpsell(add.closest('[data-up]')); return; }
    var slide = t.closest('[data-ccc-slide]');
    if (slide) {
      var track = root.querySelector('.ccc__ups-track');
      track.scrollBy({ left: parseInt(slide.getAttribute('data-ccc-slide'), 10) * track.clientWidth, behavior: 'smooth' });
    }
  });
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-ccc-code-form]');
    if (!form) return;
    e.preventDefault();
    applyCode(form.elements.code.value);
  });
  root.addEventListener('input', function (e) { if (e.target.id === 'CccCode') code.draft = e.target.value; });
  root.addEventListener('change', function (e) { if (e.target.matches('[data-ccc-prot]')) setProt(e.target.checked, e.target); });
  /* Picking a colour or size redraws only that upsell card (new image, price and variant). */
  root.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ccc-opt]'), card = sel && sel.closest('[data-up]');
    if (!card) return;
    var h = card.getAttribute('data-up'), i = sel.getAttribute('data-ccc-opt');
    picks[h] = picks[h] || pickedVariant(productData[h]).options.slice();
    picks[h][+i] = sel.value;
    var tmp = document.createElement('ul');
    tmp.innerHTML = upHtml(h);
    var fresh = tmp.firstChild;
    card.replaceWith(fresh);
    fresh.querySelector('[data-ccc-opt="' + i + '"]').focus();
  });

  /* ---------- Open / close ---------- */
  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ccc-lock');
    /* The closed drawer is laid out (only hidden), so adding the class directly still animates; no rAF, which background tabs pause. */
    root.classList.add('is-open');
    panel.focus({ preventScroll: true });
    if (!cart) refresh();
    clearInterval(timer);
    timer = setInterval(tick, 1000);
  }
  function close() {
    if (!root.classList.contains('is-open')) return;
    clearInterval(timer);
    code.msg = null;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ccc-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- Hooks into the theme and other scripts ---------- */
  /* Header cart icon (and any /cart link) opens this drawer instead of the theme's quick cart. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-sub-id="quickCart"][data-open-overlay], a[href="' + BASE + 'cart"]');
    if (!t || root.contains(t)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
    refresh();
  }, true);

  /* Theme, GemPages and Cocoon page scripts announce adds with this event; the drawer handles it alone. */
  window.addEventListener('theme-cart:updated', function (e) {
    e.stopImmediatePropagation();
    var openIt = !(e.detail && e.detail.shouldOpenCart === false);
    refresh().then(function () { if (openIt) open(); });
  }, true);

  /* Any other script that changes the cart through the AJAX API (fetch or XHR). */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function onExternal(url) {
    var isAdd = /\/cart\/add/.test(url);
    refresh().then(function () { if (isAdd) open(); });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    var p = nativeFetch(input, init);
    if (CART_RE.test(url)) p.then(function (r) { if (r.ok) onExternal(url); }).catch(function () {});
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open, xSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, url) { this.__cccUrl = url; return xOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    var x = this;
    if (CART_RE.test(x.__cccUrl || '')) x.addEventListener('load', function () { if (x.status < 400) onExternal(x.__cccUrl); });
    return xSend.apply(this, arguments);
  };

  /* Plain add-to-cart forms that no other script handled would leave the page for /cart:
     send them through the AJAX API instead, then open the drawer. Runs last (bubble phase), so theme handlers go first. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (e.defaultPrevented || !form.action || !/\/cart\/add(\.js)?(\?|$)/.test(form.action) || root.contains(form)) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    nativeFetch(BASE + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message || T.error); }); })
      .then(refresh)
      .then(open)
      .catch(function (err) { refresh().then(open).then(function () { live.textContent = err.message; }); })
      .then(function () { if (btn) btn.disabled = false; });
  });

  /* Cart changes made in another tab. */
  document.addEventListener('visibilitychange', function () { if (!document.hidden && cart) refresh(); });

  window.cocoonCart = { open: open, close: close, refresh: refresh };
  refresh();
})();
